import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import {coreReducers} from 'eaternity-core/build/redux/coreReducers'
import config from './modules/config'

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    ...coreReducers,
    config,
  })

export default createRootReducer
